import { render, staticRenderFns } from "./ChannelsLaunch.vue?vue&type=template&id=5fc85693&scoped=true"
import script from "./ChannelsLaunch.vue?vue&type=script&lang=js"
export * from "./ChannelsLaunch.vue?vue&type=script&lang=js"
import style0 from "./ChannelsLaunch.vue?vue&type=style&index=0&id=5fc85693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc85693",
  null
  
)

export default component.exports